import { Trans, useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { InlineNotification, Text, TextLink } from '@frontend/design-system';

export const OverrideNotification = ({
  callRouteName,
  callRouteId,
}: {
  callRouteName: string;
  callRouteId: string;
}) => {
  const { t } = useTranslation('phone');

  const { navigate } = useSettingsNavigate();

  const OverrideLinkV2 = () => {
    return (
      <TextLink
        onClick={() =>
          navigate({
            to: '/phone/overrides',
            context: { openEditModal: true, callRouteId: callRouteId },
          })
        }
      >
        {t('override')}
      </TextLink>
    );
  };

  return (
    <InlineNotification status='warn' size='large'>
      <Text size='medium'>
        <Trans t={t}>
          An <OverrideLinkV2 /> is turned on for the {callRouteName} call route. Calls will not route according to Phone
          Hour routing until the override is removed.
        </Trans>
      </Text>
    </InlineNotification>
  );
};
